'use client';

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';
import { StoreReviewEntity } from '@/services/types/store-review.type';
import Autoplay from 'embla-carousel-autoplay';
import { useEffect, useState } from 'react';
import CommonReviewCard from './common-review-card';

const CommonReviewCarousel = ({
  reviews,
}: {
  reviews: StoreReviewEntity[];
}) => {
  const [pcApi, setPcApi] = useState<CarouselApi>();
  const [mobileApi, setMobileApi] = useState<CarouselApi>();
  const [pcCurrentSlide, setPcCurrentSlide] = useState(0);
  const [mobileCurrentSlide, setMobileCurrentSlide] = useState(0);

  useEffect(() => {
    if (!mobileApi && !pcApi) return;

    const cleanups: (() => void)[] = [];

    if (mobileApi) {
      const onMobileSelect = () => {
        setMobileCurrentSlide(mobileApi.selectedScrollSnap());
      };
      mobileApi.on('select', onMobileSelect);
      onMobileSelect();
      cleanups.push(() => mobileApi.off('select', onMobileSelect));
    }

    if (pcApi) {
      const onPcSelect = () => {
        setPcCurrentSlide(pcApi.selectedScrollSnap());
      };
      pcApi.on('select', onPcSelect);
      onPcSelect();
      cleanups.push(() => pcApi.off('select', onPcSelect));
    }

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, [mobileApi, pcApi]);

  // const handlePrevClick = () => {
  //   pcApi?.scrollPrev();
  //   const autoplay = pcApi?.plugins().autoplay;
  //   if (!autoplay) return;
  //   autoplay.stop();
  //   setTimeout(() => autoplay.play(), 1000);
  // };

  // const handleNextClick = () => {
  //   pcApi?.scrollNext();
  //   const autoplay = pcApi?.plugins().autoplay;
  //   if (!autoplay) return;
  //   autoplay.stop();
  //   setTimeout(() => autoplay.play(), 1000);
  // };

  if (!reviews?.length) {
    return null;
  }

  return (
    <>
      {/* 웹 버전 */}
      <div className="desktop:block hidden">
        <div className="relative">
          <Carousel
            setApi={setPcApi}
            opts={{
              align: 'center',
              loop: true,
              slidesToScroll: 1,
            }}
            plugins={[
              Autoplay({
                delay: 3000,
                stopOnMouseEnter: true,
                stopOnInteraction: false,
              }),
            ]}
          >
            <CarouselContent className="mx-auto -ml-[293px]">
              {reviews.map((review, idx) => {
                // 현재 슬라이드의 이전 1개부터 다음 2개까지 총 4개를 opacity-100으로 표시
                const isVisible =
                  idx ===
                    (pcCurrentSlide - 1 + reviews.length) % reviews.length ||
                  idx === pcCurrentSlide ||
                  idx === (pcCurrentSlide + 1) % reviews.length ||
                  idx === (pcCurrentSlide + 2) % reviews.length;

                return (
                  <CarouselItem
                    key={review.id}
                    className={cn(
                      'h-[192px] w-[277px] flex-shrink-0 basis-[277px]',
                      isVisible ? 'opacity-100' : 'opacity-50',
                    )}
                  >
                    <CommonReviewCard {...review} />
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>
        </div>
        {/* <div className="web-w relative mx-auto">
          <Button
            onClick={handlePrevClick}
            disabled={!pcApi}
            className="absolute -top-[150px] left-10 z-1 -translate-y-1/2 shadow-none"
          >
            <ImageOptimizer
              src="/images/icons/icon_slide_left.svg"
              alt="이전 슬라이드"
              width={55}
              height={55}
              className="cursor-pointer rounded-full hover:bg-gray-100"
            />
          </Button>
          <Button
            onClick={handleNextClick}
            disabled={!pcApi}
            className="absolute -top-[150px] right-10 z-1 -translate-y-1/2 shadow-none"
          >
            <ImageOptimizer
              src="/images/icons/icon_slide_right.svg"
              alt="다음 슬라이드"
              width={55}
              height={55}
              className="cursor-pointer rounded-full hover:bg-gray-100"
            />
          </Button>
        </div> */}
      </div>

      {/* 모바일 버전 */}
      <div className="desktop:hidden overflow-hidden">
        <Carousel
          setApi={setMobileApi}
          opts={{
            loop: true,
            align: 'start',
            slidesToScroll: 1,
            containScroll: 'trimSnaps',
          }}
          plugins={[
            Autoplay({
              delay: 3000,
              stopOnMouseEnter: true,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent className="mx-auto">
            {reviews.map((review, idx) => (
              <CarouselItem
                key={review.id}
                className={cn(
                  'h-[192px] w-[277px] flex-shrink-0 basis-[277px]',
                  idx === mobileCurrentSlide && 'pl-6',
                )}
              >
                <CommonReviewCard {...review} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </>
  );
};

export default CommonReviewCarousel;
